import { format, unwrapFunctionStore } from 'svelte-i18n';

import { calculateHeightToBottom } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const diagnosticsShowMore = {
  element: '#diagnostics-tab',
  popover: {
    title: 'Viewing Diagnostics',
    description:
      'To view integration diagnostics, click the <strong>&quot;Diagnostics&quot;</strong> tab. This will display additional information about the integration, including the HTML Source, Rendered HTML, Rendered Text and a diagnostics tool.',
    side: 'top',
    align: 'start',

    onNextClick: () => {
      const diagnosticsTab = document.querySelector('#diagnostics-tab');
      const spinnerSelector = '.section .loading';

      if (diagnosticsTab) {
        diagnosticsTab.click();

        setTimeout(() => {
          const interval = setInterval(() => {
            if (!document.querySelector(spinnerSelector)) {
              clearInterval(interval);
              GLOBAL_DRIVER_OBJECT.moveNext();
            }
          }, 100);
        }, 360);
      }
    }
  }
};

export const diagnosticsHtmlSource = {
  element: '.section .source-tour',
  popover: {
    title: 'HTML Source',
    description: 'The HTML Source tab displays the raw HTML code for the integration.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const parentSelector = '#edit-integration > div > div > div > div.tabs > div.tab-content > div:nth-child(1)';
      const parent = document.querySelector(parentSelector);
      const parentHeight = parent.offsetHeight;

      const element = document.querySelector('.section .source-tour');
      const heightToBottom = calculateHeightToBottom(element);

      if (parentHeight > heightToBottom) {
        element.style.height = `${heightToBottom}px`;
      } else {
        diagnosticsHtmlSource.element = parentSelector;
      }
    },
    onPrevClick: () => {
      const integrationTab = document.querySelector('#integration-tab');

      if (integrationTab) {
        integrationTab.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    }
  }
};

export const diagnosticsRenderedHtml = {
  element: '#edit-integration > div > div > div > div.tabs > div.tab-content > div:nth-child(2)',
  popover: {
    title: 'Rendered HTML',
    description: 'The Rendered HTML displays the integration as it appears in the email client.',
    side: 'right',
    align: 'center'
  }
};

export const diagnosticsRenderedText = {
  element: '#edit-integration > div > div > div > div.tabs > div.tab-content > div:nth-child(3)',
  popover: {
    title: 'Rendered Text',
    description: 'The Rendered Text displays the fallback text that is rendered inside the email client.',
    side: 'right',
    align: 'center'
  }
};

export const diagnosticsTool = {
  element: '#edit-integration > div > div > div > div.tabs > div.tab-content > div:nth-child(4)',
  popover: {
    title: 'Diagnostics Tool',
    description: 'The diagnostic tool can be used to verify API responses for various recipient email addresses.',
    side: 'right',
    align: 'center'
  }
};
